import React from 'react';
import { Smartphone, QrCode, Speaker, Globe, Briefcase, ArrowRight, Award, Wrench } from 'lucide-react';
import { SOLUTIONS } from '../mock/mock';

const iconMap = { Smartphone, QrCode, Speaker, Globe, Briefcase };

const SolutionCard = ({ item, i }) => {
  const Icon = iconMap[item.icon];
  return (
    <div className="group relative bg-white rounded-2xl p-5 border border-purple-100 hover-lift soft-shadow overflow-hidden">
      <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-purple-100/0 group-hover:bg-purple-100/40 blur-2xl transition-all duration-500" />

      <div className="relative">
        <div className="w-14 h-14 rounded-2xl gradient-primary flex items-center justify-center soft-shadow group-hover:scale-110 transition-transform duration-300">
          <Icon className="w-7 h-7 text-white" />
        </div>
        <div className="mt-3 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-purple-50 text-[#5F259F] text-[10px] font-bold uppercase tracking-wide">
          {item.tag}
        </div>
        <h4 className="mt-2 text-[15px] font-extrabold text-slate-900 leading-tight">{item.title}</h4>
        <p className="mt-1.5 text-[12px] text-slate-600 leading-relaxed">{item.desc}</p>
        <div className="mt-3 flex items-center gap-1 text-[12px] font-bold text-[#5F259F] group-hover:gap-2 transition-all">
          Learn More <ArrowRight className="w-3.5 h-3.5" />
        </div>
      </div>
    </div>
  );
};

const Solutions = () => {
  return (
    <div>
      <div className="mb-5">
        <h3 className="text-2xl lg:text-[26px] font-extrabold text-slate-900">Our Solutions <span className="gradient-text">for Your Business</span></h3>
        <div className="h-1 w-16 rounded-full gradient-primary mt-2" />
        <p className="text-sm text-slate-600 mt-2">A complete suite of PhonePe merchant products, tailored for your growth.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {SOLUTIONS.map((s, i) => (
          <SolutionCard key={s.title} item={s} i={i} />
        ))}
      </div>

      {/* Offers + Installation */}
      <div className="grid md:grid-cols-2 gap-4 mt-5">
        <div className="relative rounded-2xl gradient-soft border border-purple-100 p-5 flex items-start gap-4 hover-lift">
          <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center soft-shadow">
            <Award className="w-6 h-6 text-[#5F259F]" />
          </div>
          <div>
            <div className="font-extrabold text-slate-900">Best Offers & Schemes</div>
            <div className="text-[12px] text-slate-600 mt-0.5">Exclusive offers for our local merchants. Save more with PhonePe.</div>
          </div>
        </div>
        <div className="relative rounded-2xl gradient-soft border border-purple-100 p-5 flex items-start gap-4 hover-lift">
          <div className="w-12 h-12 rounded-2xl bg-white flex items-center justify-center soft-shadow">
            <Wrench className="w-6 h-6 text-[#5F259F]" />
          </div>
          <div>
            <div className="font-extrabold text-slate-900">Quick Installation</div>
            <div className="text-[12px] text-slate-600 mt-0.5">Fast installation by our verified team. Start accepting payments in no time.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
